import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
  styled,
  alpha,
} from "@mui/material";
import React, { useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import WorkIcon from "@mui/icons-material/Work";
import AttributionIcon from "@mui/icons-material/Attribution";
import EngineeringIcon from "@mui/icons-material/Engineering";
import Image from "next/image";
import salonTymTeam from "../../assets/salontym_team.jpg";
import join from "../../assets/join.png";
import WorkLife from "./WorkLife";
import WorkLifeBalance from "./WorkLifeBalance";
import WorkLifeGallery from "./WorkLifeGallery";

const StyledTextField = styled(TextField)({
  "& .MuiInputAdornment-positionStart": {
    marginRight: "5px",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    "&.Mui-focused fieldset": {
      borderColor: "#1f7a4d",
    },
  },
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
});

const Career = ({}) => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    address: "",
    mobile: "",
    city: "",
    pincode: "",
    role: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDetails = (e: any) => {
    const { name, value } = e.target;
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    console.log("Selected file:", file);
    setSelectedFile(file);
  };

  const handleSubmit = () => {
    setValues({
      name: "",
      email: "",
      address: "",
      mobile: "",
      city: "",
      pincode: "",
      role: "",
    });
    setSelectedFile(null);

    // const formData = new FormData();
    // formData.append('pdfFile', selectedFile);
    // formData.append('name', name);
    // const customerUpdateRequest = new CustomerUpdateRequest();
    // customerUpdateRequest.name = values.name;
    // customerUpdateRequest.workEmail = values.email;
    // customerUpdateRequest.dob = values.date;
    // customerUpdateRequest.gender = values.gender;
    // console.log(customerUpdateRequest);
    // // handleLoginCloseAfterSignUp();
    // apiService
    //   .post(
    //     apiService.updateCustomerDetails,
    //     customerUpdateRequest,
    //     getToken()!
    //   )
    //   .then((value) => {
    //     alert(value?.message);
    //     getCustomerDetails();
    //   });
  };

  return (
    <Box
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        px: { xs: 0, sm: 0 },
        py: { xs: 2, sm: 3 },
        pb: { xs: 10, sm: 5 },
      }}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 16px 40px rgba(15, 23, 17, 0.1)",
          mb: 3,
        }}
      >
        <Image
          height={500}
          width={1500}
          src={salonTymTeam}
          alt="SalonTym team"
          style={{
            height: "auto",
            width: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(18,53,36,0.25) 0%, rgba(11,23,16,0.65) 100%)",
            borderRadius: "inherit",
          }}
        />
        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            px: 2,
            fontWeight: 800,
            letterSpacing: "-0.03em",
            textAlign: "center",
            fontSize: { xs: "1.5rem", sm: "2.25rem", md: "2.75rem" },
            lineHeight: 1.2,
            textShadow: "0 4px 24px rgba(0,0,0,0.35)",
            maxWidth: "90%",
          }}
        >
          Life at SalonTym
        </Typography>
      </Box>
      <WorkLife />
      <WorkLifeBalance />
      <WorkLifeGallery />
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          fontWeight: 800,
          letterSpacing: "-0.03em",
          background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          fontSize: { xs: "1.15rem", sm: "1.5rem", md: "1.75rem" },
          lineHeight: 1.35,
          px: { xs: 1, sm: 2 },
          mb: 3,
        }}
      >
        Join our sparkling squad — team happiness, excellence, and fun on every
        step of the journey.
      </Typography>
      <Box
        sx={{
          textAlign: "center",
          position: "relative",
          borderRadius: "20px",
          overflow: "hidden",
          mb: 3,
          boxShadow: "0 16px 40px rgba(15, 23, 17, 0.1)",
        }}
      >
        <Image
          height={500}
          width={1500}
          src={join}
          alt="Join SalonTym"
          style={{
            height: "auto",
            maxHeight: "25rem",
            width: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(18,53,36,0.35) 0%, rgba(11,23,16,0.7) 100%)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            px: 2,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#fff",
              fontWeight: 800,
              letterSpacing: "-0.02em",
              fontSize: { xs: "1.25rem", sm: "1.75rem" },
              mb: 2,
              textShadow: "0 2px 16px rgba(0,0,0,0.4)",
            }}
          >
            Want to join us?
          </Typography>
          <Button
            variant="contained"
            sx={{
              px: 3,
              py: 1.25,
              borderRadius: "14px",
              textTransform: "none",
              fontWeight: 800,
              background: "#fff",
              color: "#1f7a4d",
              boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              "&:hover": {
                background: alpha("#fff", 0.95),
                color: "#123524",
              },
            }}
            href="#career-application-form"
            component="a"
          >
            Fill out the form below
          </Button>
        </Box>
      </Box>
      <Box
        id="career-application-form"
        sx={{
          display: { xs: "block", sm: "block", md: "grid" },
          width: "100%",
          mx: "auto",
          borderRadius: "20px",
          border: `1px solid ${alpha("#1f7a4d", 0.12)}`,
          boxShadow: "0 12px 32px rgba(15, 23, 17, 0.06)",
          bgcolor: "#fff",
          p: { xs: 2, sm: 3 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: "#0b1710",
            mb: 2,
            gridColumn: "1 / -1",
          }}
        >
          Career application
        </Typography>
        <Box
          sx={{
            display: { xs: "block", sm: "block", md: "flex" },
            justifyContent: "space-evenly",
            alignItems: "center",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "50%" },
              padding: { xs: "0px", sm: "0px", md: "1rem" },
              margin: "auto",
            }}
          >
            <StyledTextField
              id="input-with-icon-adornment"
              label="Full Name"
              required
              name="name"
              type="text"
              value={values.name}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircleIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Mobile Number"
              required
              name="mobile"
              type="number"
              value={values.mobile}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocalPhoneIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="City"
              name="city"
              type="text"
              value={values.city}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationCityIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="PinCode"
              required
              name="pincode"
              type="text"
              value={values.pincode}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <WorkIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "50%" },
              padding: { xs: "0px", sm: "0px", md: "1rem" },
              margin: "auto",
            }}
          >
            <StyledTextField
              id="input-with-icon-adornment"
              label="Email"
              required
              name="email"
              type="email"
              value={values.email}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Address"
              required
              name="address"
              type="text"
              value={values.address}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttributionIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Job role"
              required
              name="role"
              type="text"
              value={values.role}
              onChange={handleDetails}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EngineeringIcon style={{ color: "#1f7a4d" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Upload Your CV"
              required
              inputProps={{
                accept: "application/pdf",
              }}
              name="Resume"
              type="file"
              // value={setSelectedFile}
              onChange={handleFileChange}
              sx={{ margin: "0.5rem auto", width: "100%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {/* <AddHomeWorkIcon style={{ color: "#15741a" }} /> */}
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <Box sx={{ width: "100%", textAlign: "center", gridColumn: "1 / -1" }}>
          <Button
            variant="contained"
            color="success"
            sx={{
              background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
              borderRadius: "14px",
              margin: "1rem 0px",
              width: { xs: "100%", sm: "min(400px, 80%)" },
              py: 1.35,
              fontWeight: 800,
              textTransform: "none",
              boxShadow: "0 10px 26px rgba(31, 122, 77, 0.28)",
              "&:hover": {
                background:
                  "linear-gradient(135deg, #0f2a1c 0%, #1a6b42 100%)",
              },
            }}
            onClick={handleSubmit}
          >
            Submit application
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Career;
